import {
  isLabelExists,
  openSwal,
} from '@root/private/js/common/securekey/util';
import { checkSecureKey } from '@root/private/js/common/securekey/check-securekey';
import { PlayerTypeEnum } from '@src/modules/players/shared/interfaces/player-configs.interface';
import { MAX_RETRY } from '@root/private/js/common/securekey/constants';
import { FRONTEND_MESSAGES } from '@root/private/js/lib/messages';

/**
 * securekey(플레이어 고급보안 기능) load 후 플레이어 재설정
 * 1. 암호 입력 플레이어
 * 2. 라벨 지정 플레이어 - 동시 재생 제한 / 워터마크 추가
 * 3. 암호 입력 + 멀티 DRM
 * 4. 엄호 입력 + 기본 DRM
 *
 * @param plyaerType
 */

const loadSecureKey = async (plyaerType: PlayerTypeEnum) => {
  let retryCount = MAX_RETRY;

  const securekey = new URLSearchParams(window.location.search).get(
    'securekey',
  );

  if (!securekey) {
    return openSwal({
      icon: 'error',
      title: FRONTEND_MESSAGES.secureKeyPasswordTitle,
      message: FRONTEND_MESSAGES.secureKeyRequestInvalid,
    });
  }

  while (retryCount) {
    try {
      /* eslint-disable no-await-in-loop */
      const checkSecureKeyResult = await checkSecureKey(
        securekey,
        plyaerType,
        retryCount,
      );
      if (!checkSecureKeyResult.isError) {
        return true;
      }
      retryCount -= 1;
    } catch (e) {
      console.error(e);
      retryCount -= 1;
    } finally {
      if (isLabelExists) {
        retryCount = 0;
      }
    }
  }

  let title: string = FRONTEND_MESSAGES.passwordTitle;
  let text: string = FRONTEND_MESSAGES.passwordRetryExceeded;
  if (isLabelExists) {
    title = FRONTEND_MESSAGES.secureKeyPasswordTitle;
    text = FRONTEND_MESSAGES.secureKeyRequestInvalid;
  }
  await openSwal({
    icon: 'error',
    title,
    message: text,
  });
};

export default loadSecureKey;
